import { h, Component } from "preact";
import Api, { FullWork } from "../../api";
import { RefreshCw } from "preact-feather";

import "./details.scss";
import Navigation, { Pages } from "../../navigation";

export interface DetailsProps {
   id: string;
}
interface DetailsState {
   work?: FullWork;
}
export class DetailsComponent extends Component<DetailsProps, DetailsState> {
   constructor(props, ctx) {
      super(props, ctx);
      this.state = { work: undefined };
   }
   componentWillMount() {
      Api.getWork(this.props.id)
         .then(work => {
            this.setState({ work: work });
         })
         .catch(err => {
            console.log(err);
            Navigation.setPage(Pages.Library, undefined);
         });
   }

   render(props: DetailsProps, { work }: DetailsState) {
      if (!this.state.work) return <div>Loading</div>;
      return (
         <div class="details-continer fancy-background">
            <div class="content elv-4">
               <div class="image">
                  <img src={work.cover} alt="" />
               </div>
               <div class="title">{work.title}</div>
               <hr />
               <div class="summary">{work.summary || "No summary"}</div>
               <hr />
               <div class="tags">
                  {work.tags.map(t => (
                     <span>{t}</span>
                  ))}
               </div>
               <div class="actions">
                  {work.type == "wattpad" && (
                     <button
                        onClick={() =>
                           Api.addWorkWithId(work.type, work.workid)
                        }
                     >
                        <RefreshCw />
                     </button>
                  )}
                  <button
                     onClick={() => {
                        if (confirm("Really delete?")) {
                           Api.deleteWork(props.id)
                              .then(() => {
                                 alert("Deleted!");
                              })
                              .catch(err => {
                                 console.error(err);
                                 alert("Could not delete!");
                              })
                              .then(() => {
                                 Navigation.setPage(Pages.Library, undefined);
                              });
                        }
                     }}
                  >
                     <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="css-i6dzq1"
                     >
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                     </svg>
                  </button>
               </div>
            </div>
         </div>
      );
   }
}
